<form [formGroup]="smsForm" name="smsForm">
  <glxy-form-field [required]="true">
    <glxy-label>{{ 'TITLE' | translate }}</glxy-label>
    <input type="text" required placeholder="My SMS template" matInput formControlName="name" />
  </glxy-form-field>
  @if (!allowDynamic) {
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'MESSAGE' | translate }}</glxy-label>
      <textarea matInput required formControlName="message" placeholder="Hello!"></textarea>
      <glxy-label>Message</glxy-label>
      <textarea
        matInput
        required
        formControlName="message"
        placeholder="Hello!"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="10"
      ></textarea>
    </glxy-form-field>
  } @else {
    <glxy-form-field [required]="true">
      <glxy-label>
        <div class="dynamic-content-selector">
          <templates-dynamic-component-selector [target]="smsText" (modelChange)="emitNewTemplateValue($event)">
          </templates-dynamic-component-selector>
        </div>
        {{ 'MESSAGE' | translate }}
      </glxy-label>
      <textarea
        #smsText
        matInput
        required
        [attr.maxLength]="setTextLimit ? textLimit : null"
        formControlName="message"
        placeholder="Hello!"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="10"
      ></textarea>
      <glxy-hint align="end" class="character-count"> {{ calculatedTextLength$$ | async }}/{{ textLimit }} </glxy-hint>
    </glxy-form-field>
  }
</form>
